import { render, staticRenderFns } from "./Ajax.vue?vue&type=template&id=5c676096&"
import script from "./Ajax.vue?vue&type=script&lang=js&"
export * from "./Ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports